/* eslint-disable max-len */
/* eslint-disable object-shorthand */
/* eslint-disable @typescript-eslint/type-annotation-spacing */
/* eslint-disable no-trailing-spaces */
/* eslint-disable prefer-const */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/quotes */
/* eslint-disable @typescript-eslint/semi */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-var */
import { Component, OnInit, ViewChild, ElementRef, NgZone } from '@angular/core';
// 
import { GlobalVariable } from '../global';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import {
  NativeGeocoder,
  NativeGeocoderOptions,
  NativeGeocoderResult,
} from '@ionic-native/native-geocoder/ngx';
import { LocalStorageService } from '../services/core/local-storage.service';
import { ModalController, Platform, ToastController, LoadingController, AlertController } from '@ionic/angular';
import { UserApiService } from '../services/user-api.service';
import { tr } from 'date-fns/locale';
import { Router, ActivatedRoute } from '@angular/router';
import { LocationService } from '../services/location.service';
declare var google;
declare let cordova: any;

@Component({
  selector: 'app-user-location',
  templateUrl: './user-location.page.html',
  styleUrls: ['./user-location.page.scss'],
})
export class UserLocationPage implements OnInit {
  @ViewChild('map') mapElement: ElementRef;

  longitude: number;
  latitude: number;
  map: any;
  geocoder = new google.maps.Geocoder();
  userAddress: any;
  accuracy: number;
  geoencoderOptions: NativeGeocoderOptions = {
    useLocale: true,
    maxResults: 8,
  };
  searchRest = []
  autocompleteItems: any;
  autocomplete: any;
  service = new google.maps.places.AutocompleteService();
  items: Object[] = [];
  addressSearch: boolean = true;
  temp: boolean = true;
  geo: any;
  showLocationIcon: boolean = false;
  addressSelected: boolean = false
  // isLocationShared='0';
  locationStatus: boolean;

  constructor(
    private storageService: LocalStorageService,
    public globals: GlobalVariable,
    private geolocation: Geolocation,
    private nativeGeocoder: NativeGeocoder,
    private platform: Platform,
    public zone: NgZone,
    public server: UserApiService,
    private modalController: ModalController,
    private toastController: ToastController,
    public loadingCtrl: LoadingController,
    private router: Router,
    private alertController: AlertController,
    private locationService: LocationService
    
  ) {
    this.autocompleteItems = [];
    this.autocomplete = {
      query: "",
    };
    // this.globals.checkGPSPermission();
  }

  ngOnInit() {
    this.locationService.locationStatus$.subscribe((status) => {
      this.locationStatus = status;
      console.log('mapelement:Status',status);
      let add = localStorage.getItem("deliveryAddress");
      // let add = this.globals.DeliveryAddress;
      console.log('mapelement:Address',add);
      if (add != null) {
        this.globals.DeliveryAddress = add;

        this.geoCode(this.globals.DeliveryAddress)
      }
      if (this.globals.DeliveryAddress == '') {
        this.getUserLocation();
      }
    });

    // Check location status on init
    this.locationService.checkLocation();
   }
   
  ionViewWillEnter() {
    console.log('view Entered');
   
  }
  close() {
    if (this.addressSelected) {
      this.modalController.dismiss(true)
      this.globals.presentToast("Delivery location saved.")
    } else {
      this.modalController.dismiss();
    }
    if (this.globals.orderOnCall) {
      this.router.navigate(['/order']);
    }
  }
  getUserLocation() {
    this.globals.presentToast("Getting Current location");
    this.geolocation
      .getCurrentPosition()
      .then((position) => {
        this.addressSearch = false;
        this.globals.userlatitude = position.coords.latitude;
        this.globals.userlongitude = position.coords.longitude;
        this.accuracy = position.coords.accuracy;
        this.globals.mycoordinates =
          position.coords.latitude + "," + position.coords.longitude;
        this.reverseGeoCoding()
      })
      .catch((error) => {
        this.globals.presentToast('Error getting location', 'middle')

      });
  }
  reverseGeoCoding() {
    let response = this.server.getAddress(this.globals.mycoordinates);
    var myadress = "";
    response.subscribe(
      (data) => {
        console.log('data from adrress api ', data);
        myadress = data.address;
        if (data.in_radius) {
          this.addressSelected = true;
          this.geoCode(myadress)
          this.globals.DeliveryAddress = myadress;
          localStorage.setItem('deliveryAddress', this.globals.DeliveryAddress);
          if (this.globals.doordashEnabled) {
            this.globals.presentToast('$' + data.delivery_meta.delivery_fee + ' Would be charged as delivery fee.', 'middle', 3000);
            this.globals.deliveryCharges = data.delivery_meta.delivery_fee;
            this.globals.cardDeliveryFee = data.delivery_meta.card_delivery_fee;
            this.globals.businessData.card_delivery_fee = data.delivery_meta.card_delivery_fee;
          }
          this.globals.inradius = data.in_radius;
        }
        else {
          this.addressSelected = false;
          this.globals.OrderType = 'pickup';
          this.globals.presentToast('Your location is not in delivery radius.please change or switch to pickup', 'middle', 2000);
        }


        // this.list();
      },
      (error) => {
        this.globals.OrderType = 'pickup';
        this.globals.presentToast(
          "Please Turn on your location."
        );
      }
    );
  }
  save() {
    if (this.addressSelected) {
      this.modalController.dismiss(true)
      this.globals.presentToast("Delivery location selected.")
      this.globals.OrderType = 'delivery'
    } else {
      this.close();
    }
  }

  loadMap() {
    console.log('mapelement',this.mapElement);
    let mapOptions = {
      center: {
        lat: this.latitude,
        lng: this.longitude,
      },
      fullscreenControlOptions: false,
      mapTypeControl: false,
      zoom: 15,
      streetViewControl: false,
      zoomControl: false,
      fullscreenControl: false,
      keyboardShortcuts: false,
      scrollwheel: false,
      scaleControl: false,
      draggable: true,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    };
    console.log('location',this.latitude + this.longitude);
    this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
    this.addMarker(this.latitude, this.longitude);
  }

  addMarker(lat: number, lng: number) {
    console.log('Marker Here', lat, lng);
    let latLng = new google.maps.LatLng(lat, lng);
    let marker = new google.maps.Marker({
      map: this.map,
      animation: google.maps.Animation.DROP,
      position: latLng,
      draggable: true,
      //   icon: {
      //     path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
      //     strokeColor: "#ffc409",
      //     scale: 5
      // },
    });
    google.maps.event.addListener(marker, 'dragend', () => {
      console.log('drag marker ', marker.getPosition())
      this.geocodePosition(marker.getPosition());
    });

    let content = 'Me';
    //add username here

    this.addInfoWindow(marker, content);
    this.showLocationIcon = true;
  }
  geocodePosition(pos) { //for geocode pos  latlong to address;
    let geocoder = new google.maps.Geocoder();
    let that
    that = this
    let res;
    geocoder.geocode
      ({
        latLng: pos
      },
        (results, status) => {
          if (status == google.maps.GeocoderStatus.OK) {
            res = results[0].formatted_address
            console.log(res)

            that.globals.mycoordinates =
              results[0].geometry.location.lat() +
              "," +
              results[0].geometry.location.lng();
            console.log(that.globals.mycoordinates)
            that.latitude = results[0].geometry.location.lat()
            //setting globallly user cords
            that.globals.userlatitude = that.latitude
            that.longitude = results[0].geometry.location.lng();
            that.globals.userlongitude = that.longitude;
            this.reverseGeoCoding()
            //  that.checkInradius(that.globals.mycoordinates);// checking if in radius
            //  that.loadMap();

            // geoCode(this.geo);

            // $("#mapErrorMsg").hide(100);
          }
          else {
            console.log('error')
            // $("#mapErrorMsg").html('Cannot determine address at this location.'+status).show(100);
          }
        }
      );
  }
  addInfoWindow(marker, content) {
    let infoWindow = new google.maps.InfoWindow({
      content: content,
    });

    google.maps.event.addListener(marker, 'click', () => {
      infoWindow.open(this.map, marker);
    });
  }
  emptySearch() { }
  setFilteredRest() { }
  saveAddress() {
    this.globals.DeliveryAddress = this.autocomplete.query;    
    this.addressSearch = false;
    this.autocompleteItems = [];
  }
  editAddress() {
    this.addressSearch = true;
  }
  dismiss() {
    this.temp = false;
    this.autocompleteItems = [];
  }
  async chooseItem(item: any) {
    const loading = await this.loadingCtrl.create({
      message: 'please wait..',
    });
    await loading.present();
    this.autocomplete.query = item;
    this.globals.DeliveryAddress = this.autocomplete.query;
    localStorage.setItem('deliveryAddress', this.globals.DeliveryAddress);
    this.addressSearch = false;
    this.addressSelected = true;
    this.temp = false;
    this.autocompleteItems = [];
    this.geo = item;
    this.autocomplete.query = '';
    this.dismiss();
    // this.reverseGeoCoding()
    this.geoCode(this.geo);
    console.log("item", item);
    console.log("geo", this.geo);
    loading.dismiss();
  }
  geoCode(address: any) {
    console.log('mapelement', address)
    let geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address: address }, (results, status) => {
      console.log('mapelement',results+ status)
      this.globals.mycoordinates =
        results[0].geometry.location.lat() +
        "," +
        results[0].geometry.location.lng();
      this.latitude = results[0].geometry.location.lat()
      this.globals.userlatitude = this.latitude
      this.longitude = results[0].geometry.location.lng();
      this.globals.userlongitude = this.longitude;
      this.checkInradius(this.globals.mycoordinates);// checking if in radius
      this.loadMap();
      this.items = []
    });
  }
  updateSearch() {
    console.log("search is on");
    console.log(this.autocompleteItems);
    console.log("length", this.autocomplete.query.length);

    if (this.autocomplete.query == "") {
      console.log("if run");
      this.autocompleteItems = [];
      this.temp = false;
      return;
    } else if (this.autocomplete.query.length >= 3) {
      console.log("else if run");
      this.temp = true;
      let me = this;
      this.service.getPlacePredictions(
        {
          input: this.autocomplete.query,
          componentRestrictions: {
            country: "us",
          },
        },
        (predictions, status) => {
          me.autocompleteItems = [];

          me.zone.run(() => {
            if (predictions != null) {
              predictions.forEach((prediction) => {
                me.autocompleteItems.push(prediction.description);
                console.log(me.autocompleteItems);
              });
            }
          });
        }
      );
    } else {
      console.log("else run");
    }
  }
  checkInradius(coords) {
    if (!this.globals.isLoading) {
      this.globals.loader();
    }
    let response = this.server.getAddress(coords)
    response.subscribe(async data => {
      this.globals.dismiss()
      console.log('checking in radius ', data);
      if (data.in_radius != true) {
        this.addressSelected = false;
        this.globals.OrderType = 'pickup';
        const toast = await this.toastController.create({
          animated: true,
          buttons: [
            {
              side: 'start',
              text: 'Close',
              handler: () => {
                this.globals.OrderType = 'pickup';
                this.modalController.dismiss();
                this.globals.presentToast('Pickup Selected.')
                console.log('Favorite clicked');
              }
            }
          ],


          // header: 'warning',
          keyboardClose: true,
          message: 'We are not delivering in your area',
          duration: 4000,

          position: 'middle',
          color: 'dark',
          cssClass: 'APP_toast',

        });
        toast.present();
      }
      else {
        localStorage.setItem('deliveryAddress', this.globals.DeliveryAddress);
        this.addressSelected = true;
        if (this.globals.doordashEnabled) {
          this.globals.presentToast('$' + data.delivery_meta.delivery_fee + ' Would be charged as delivery fee.', 'middle', 3000);
          this.globals.deliveryCharges = data.delivery_meta.delivery_fee;
          this.globals.cardDeliveryFee = data.delivery_meta.card_delivery_fee;

          this.globals.businessData.delivery_fee = data.delivery_meta.delivery_fee;
          this.globals.businessData.card_delivery_fee = data.delivery_meta.card_delivery_fee;

        }
        else {
          this.globals.presentToast(
            '$' +
            data.delivery_meta.delivery_fee +
            ' Would be charged as delivery fee.',
            'middle',
            3000
          );
          this.globals.deliveryCharges = data.delivery_meta.delivery_fee;
          this.globals.cardDeliveryFee = data.delivery_meta.card_delivery_fee;

          this.globals.businessData.delivery_fee =
            data.delivery_meta.delivery_fee;
          this.globals.businessData.card_delivery_fee =
            data.delivery_meta.card_delivery_fee;
        }
        this.globals.inradius = data.in_radius;
      }

    }, err => {
      this.globals.dismiss()
      this.globals.isLoading = false
    })
  }
  reloadApp() {
    window.location.reload();
  }
}
